module.exports = __webpack_public_path__ + "img/avatar_robot.e1e4d661.png";